import { AgeVerificationMethodPriority } from "@next-platform/packages-ts-types";

import { AgeVerificationMethods, PageLayout, PageSize } from "@/components";
import Trans from "@/components/Trans/Trans";

const AgeVerificationFallback = () => {
  return (
    <PageLayout size={PageSize.Small} className="flex min-h-screen items-center justify-center flex-col gap-xl">
      <AgeVerificationMethods priority={AgeVerificationMethodPriority.FALLBACK} skipStatusCheck />
      <a href="https://docs.spicychat.ai/advanced/age-verification" target="_blank" className="text-blue-10 hover:underline">
        <Trans i18nKey="ageVerification:section.help.link.faqDocs" />
      </a>
    </PageLayout>
  );
};

export default AgeVerificationFallback;
